module.exports = __webpack_public_path__ + "img/img-3-9.75d742f3.webp";